import {autoinject, bindable} from 'aurelia-framework';
import {UrlState} from "../services/url-state";

@autoinject()
export class TabsCustomAttribute {

  @bindable({ primaryProperty: true }) id: string;
  @bindable('tabs-id') tabsId: string;

  constructor(private element: Element,
              private urlState: UrlState) { }

  valueChanged(newValue, oldValue) {
    //
  }

  public onChange(state: string) {

  }
}
